import { EntityTypes } from "../../EntityTypes";
import { IHydraResource, ITimestampable } from "../../types";

export enum MediaType {
    URL = "url",
    FILE = "file",
}

export const SUPPORTED_IMAGE_MIME_TYPES = ["image/jpeg", "image/png", "image/webp"];

export interface IMediaResource extends IHydraResource, ITimestampable {
    title: string;
    mimetype: string;
    size: number;
    width?: number;
    height?: number;
    url: string;
    type: MediaType;
}

export const isMediaResource = (resource: IHydraResource): resource is IMediaResource => {
    return resource["@type"] === EntityTypes.MEDIA;
};
